<template>
  <div class="header">
    <div class="title-overlay"></div>
    <div class="header-container">
      <div class="app-name">
        <router-link to="/" style="margin-top: -20px">
          <img src="@/assets/logo.png" alt="西安伟思特声学logo" class="logo-img logo-mark"/>
          <img src="@/assets/logo-2.png" alt="西安伟思特声学" class="logo-img logo-text"/>
        </router-link>
      </div>
      <div class="header-rout desktop-menu">
        <div class="container d-flex justify-content-between align-items-center">
          <el-menu mode="horizontal" router class="transparent-menu">
            <el-menu-item index="/"><strong>首页</strong></el-menu-item>
            <el-menu-item index="/"><strong>公司服务</strong></el-menu-item>
            <el-menu-item index="/customerCases"><strong>客户案例</strong></el-menu-item>
            <el-menu-item index="/news"><strong>新闻资讯</strong></el-menu-item>
            <el-menu-item index="/about"><strong>关于我们</strong></el-menu-item>
            <el-menu-item index="/contact"><strong>联系我们</strong></el-menu-item>
            <el-menu-item index="/faq"><strong>常见问题解答</strong></el-menu-item>
          </el-menu>
        </div>
      </div>
      <button
          class="mobile-menu-toggle"
          :class="{ active: mobileMenuOpen }"
          @click="mobileMenuOpen = !mobileMenuOpen"
          aria-label="菜单"
      >
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </button>
    </div>

    <transition name="slide-fade">
      <div v-if="mobileMenuOpen" class="mobile-menu">
        <el-menu mode="vertical" router class="transparent-menu mobile-menu-list" @select="mobileMenuOpen = false">
          <el-menu-item index="/"><strong>首页</strong></el-menu-item>
          <el-menu-item index="/"><strong>公司服务</strong></el-menu-item>
          <el-menu-item index="/customerCases"><strong>客户案例</strong></el-menu-item>
          <el-menu-item index="/news"><strong>新闻资讯</strong></el-menu-item>
          <el-menu-item index="/about"><strong>关于我们</strong></el-menu-item>
          <el-menu-item index="/contact"><strong>联系我们</strong></el-menu-item>
          <el-menu-item index="/faq"><strong>常见问题解答</strong></el-menu-item>
        </el-menu>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      mobileMenuOpen: false
    };
  },
  created() {

  },
  methods: {}
};
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 90px;
  background: white;
  display: flex;
  justify-content: center;
  border-bottom: #eeeeee solid 2px;
  z-index: 1000;
}

.header-container {
  width: 1000px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 999;
}

.title-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20%;
  background: linear-gradient(rgb(255, 255, 255), rgb(199, 198, 198));
  z-index: 998;
  border-radius: 4px;
}

.app-name a {
  display: flex;
  align-items: center;
  color: #409EFF;
  font-size: 24px;
  text-decoration: none;
}

.logo-img {
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  outline: none;
}

.logo-mark {
  width: 70px;
  height: 50px;
  margin: 5px 5px -5px 0;
}

.logo-text {
  height: 50px;
  margin: 5px 5px -5px 0;
}

.transparent-menu {
  background-color: transparent;
  border-bottom: none;
  color: #ffffff;
}

.transparent-menu .el-menu-item:hover {
  background-color: rgb(210, 247, 252, 0.8) !important;
}

.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1001;
  padding: 0;
}

.mobile-menu-toggle .bar {
  display: block;
  width: 24px;
  height: 2px;
  margin: 4px 0;
  background: #333;
  transition: all 0.3s ease;
  border-radius: 1px;
}

.mobile-menu-toggle.active .bar:nth-child(1) {
  transform: translateY(10px) rotate(45deg);
}

.mobile-menu-toggle.active .bar:nth-child(2) {
  opacity: 0;
}

.mobile-menu-toggle.active .bar:nth-child(3) {
  transform: translateY(-10px) rotate(-45deg);
}

.mobile-menu {
  display: none;
  position: absolute;
  top: 90px;
  left: 0;
  right: 0;
  background: white;
  border-bottom: #eeeeee solid 2px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 997;
}

.mobile-menu-list {
  width: 100%;
  border-right: none;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.25s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media screen and (min-width: 769px) {
  .app-name a {
    position: fixed;
    top: 35px;
    left: 50px;
  }
}

@media screen and (max-width: 768px) {
  .header {
    height: 70px;
  }

  .header-container {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
  }

  .desktop-menu {
    display: none;
  }

  .mobile-menu-toggle {
    display: flex;
  }

  .mobile-menu {
    display: block;
  }

  .app-name a {
    font-size: 18px;
  }

  .logo-mark {
    width: 50px;
    height: 36px;
  }

  .logo-text {
    height: 36px;
  }
}
</style>
